/**
 * Creates and assigns a state tag to a project
 */
export const createStateTag = async (
  tag,
  projectRow,
  updateStateTag,
  handleClose,
) => {
  try {
    const response = await updateStateTag(projectRow, tag.SK)
    handleClose()
  } catch (error) {
    console.error("❌ Error calling createStateTag:", error)
  }
}

/**
 * Creates a default tag and assigns it to the project
 */
export const createAndAssignDefaultTag = async (
  option,
  organizationId,
  createTagMutation,
  setLocalTags,
  createStateTagFn,
) => {
  try {
    const newLocalTag = {
      SK: `local-${Date.now()}`,
      properties: {
        name: option.tag,
        color: option.color,
        state: option.state,
      },
    }
    setLocalTags(prev => [...prev, newLocalTag])

    const createdTag = await new Promise((resolve, reject) => {
      createTagMutation.mutate(
        {
          organization_id: organizationId,
          category: "S",
          object_type: "project",
          name: option.tag,
          color: option.color,
          state: option.state,
        },
        {
          onSuccess: data => resolve(data),
          onError: error => reject(error),
        },
      )
    })

    await createStateTagFn(createdTag)
  } catch (error) {
    console.error("❌ Error creating and assigning default tag:", error)
  }
}

/**
 * Deletes a tag from the organization
 */
export const deleteTag = async (
  tag,
  organizationId,
  deleteTagMutation,
  setHiddenTags,
) => {
  setHiddenTags(prev => [...prev, tag.SK])
  deleteTagMutation.mutate({
    organization_id: organizationId,
    sk: tag.SK,
  })
}

/**
 * Handles keyboard input for creating new tags
 */
export const handleKeyDown = (
  e,
  option,
  inputValue,
  tags,
  localTags,
  organizationId,
  createTagMutation,
  setLocalTags,
  setInputValue,
  setShowInputIdx,
) => {
  if (e.key === "Enter" && inputValue.trim()) {
    const exists = [...(tags || []), ...localTags].some(
      tag =>
        tag.properties.name.toLowerCase() === inputValue.trim().toLowerCase() &&
        tag.properties.state === option.state,
    )
    if (exists) {
      return
    }
    const newTag = {
      SK: `local-${Date.now()}`,
      properties: {
        name: inputValue.trim(),
        color: option.color,
        state: option.state,
      },
    }
    setLocalTags(prev => [...prev, newTag])
    createTagMutation.mutate({
      organization_id: organizationId,
      category: "S",
      object_type: "project",
      name: inputValue.trim(),
      color: option.color,
      state: option.state,
    })
    setInputValue("")
    setShowInputIdx(null)
  }
}
